import { render, staticRenderFns } from "./BranchLogo.vue?vue&type=template&id=15953260&scoped=true&"
import script from "./BranchLogo.vue?vue&type=script&lang=js&"
export * from "./BranchLogo.vue?vue&type=script&lang=js&"
import style0 from "./BranchLogo.vue?vue&type=style&index=0&id=15953260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15953260",
  null
  
)

export default component.exports